import React from "react";
import InputMask from "react-input-mask";
import { FaArrowLeft, FaBars } from "react-icons/fa";
import * as SCREENS from "../constants/screens";
import { useBlueBody } from "../hooks/useBlueBody";

export default function Phone({ dataManager, sidebarManager }) {
  const { data, setData, sendDataToSheet } = dataManager;
  const { openSidebar } = sidebarManager;
  useBlueBody();

  function prevScreen() {
    setData({ ...data, screen: SCREENS.CREDIT });
  }

  function nextScreen() {
    if (window !== undefined) localStorage.setItem("phone", data.phone);

    sendDataToSheet(
      data.name,
      data.phone,
      data.associateMode,
      data.redirected,
      data.administrator,
      `${data.name} está prestes a ver os resultados da simulação`
    );

    setData({ ...data, screen: SCREENS.RESULTS });
  }

  function setPhone(phone) {
    setData({ ...data, phone: phone });
  }

  const isPhoneValid = () => {
    const validPhoneRegex = RegExp(/\([0-9]{2}\) [0-9]{5}-[0-9]{4}/g);
    return validPhoneRegex.test(data.phone);
  };

  return (
    <section className="administrators-screen">
      <div className="container mb-5">
        <div className="row justify-content-between align-items-center">
          <div className="col-auto">
            <FaArrowLeft
              role="button"
              className="icon-bar"
              onClick={prevScreen}
            />
          </div>
          <div className="col-8">
            <div className="progress">
              <div
                className="progress-bar"
                style={{ width: "80%" }}
                role="progressbar"
                aria-label="Progress Bar"
                aria-valuenow="80"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
          </div>
          <div className="col-auto">
            <FaBars role="button" className="icon-bar" onClick={openSidebar} />
          </div>
        </div>
      </div>
      <div className="container mb-5">
        <h1>Qual seu telefone?</h1>
        <h2>Digite seu telefone no campo abaixo.</h2>
      </div>
      <div className="bottom-panel container">
        <InputMask
          type="tel"
          value={data.phone}
          mask="(99) 99999-9999"
          placeholder="WhatsApp/Celular"
          className="form-control mb-2"
          onChange={(e) => setPhone(e.target.value)}
        />
        {!isPhoneValid() ? (
          <div className="alert alert-primary" role="alert">
            O número deve ter DDD + 9 dígitos.
          </div>
        ) : null}
        <button
          className="btn btn-secondary mt-auto"
          onClick={nextScreen}
          disabled={!isPhoneValid()}
        >
          Continuar
        </button>
      </div>
    </section>
  );
}
